// extracted by mini-css-extract-plugin
module.exports = {"Content":"MainContent_Content__2g0RO","BodyAndFooter":"MainContent_BodyAndFooter__2pTod","MenuItem":"MainContent_MenuItem__w2EdI"};